import React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './queryClient';
import AdminJobs from './Jobs';
interface JobsWithQueryProps {
  apiKey: string;
  aiStudioEnabled: boolean;
  jobStatusFeature: boolean;
  newApplyWithSeekEnabled: boolean;
  userTimezone: string;
}

export default function JobsWithQuery(props: JobsWithQueryProps) {
  return (
    <QueryClientProvider client={queryClient}>
          <AdminJobs {...props} />
    </QueryClientProvider>
  );
} 
